<template>
  <div id="app">
    <!-- <img class="bodyBack" src="./assets/login_mainbg.jpg" /> -->
    <!-- <div class="bodyBack"></div> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      scale: 1
    }
  },
  components: {
  },
  methods: {
    bodyScale() {
      var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
      this.scale = devicewidth / 1920; // 分母——设计稿的尺寸
      console.log(this.scale);
      document.body.style.zoom = this.scale;//放大缩小相应倍数
    }
  },
  created() {
    // this.bodyScale();
  },
  // watch: {
  //   'scale': function (newVal) {
  //     console.log(newVal);
  //     this.bodyScale();
  //   }
  // }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100%;
}

/* ::-webkit-scrollbar{
  width: 0px;
  background: #f2f2f2;
}


*/
/* .bodyBack {
  position: absolute;
  width: 1920px;
  top: 0;
  left: 0;
} */
</style>
